import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getCreationReasonCopy, getParkEstimate } from '../../helpers/url_data_agent_creation_requests_helpers';
import { formatNumber } from '../../helpers/url_data_agent_evaluations_helpers';

import './CreationRequestParkReport.scss';

/**
 * What parking a batch's pins did, or with `isCheck` what it would do, with the estimate a check gives and the pins left out
 * by reason, each copyable.
 * @param {Object} lane — the batch list's lane, which prices and times a check
 */
const CreationRequestParkReport = ({ report, isCheck, lane, chunkCount }) => {
  // Display data
  const facts = [
    { key: 'links', label: isCheck ? 'links APM will read' : 'links parked for APM to read', isTotal: true },
    { key: 'onIgnoredDomains', label: 'on sites APM otherwise ignores' },
    { key: 'awaitingCrawl', label: 'waiting for the crawler first' },
    { key: 'inLinksToCheckWhileWaiting', label: 'also in Links to Check while they wait' },
    { key: 'bulkDismissed', label: isCheck ? 'old bulk dismissals to clear' : 'old bulk dismissals cleared' },
    { key: 'replacedCreationRequests', label: 'read again, replacing another batch’s ready request or an earlier refused or failed one' }
  ].filter(fact => fact.isTotal || report[fact.key] > 0);
  const skippedReasons = _.orderBy(Object.entries(report.skipped), ([, pinIds]) => pinIds.length, 'desc');
  const estimate = isCheck ? getParkEstimate(report.links, lane) : null;

  const copyPinIds = async pinIds => {
    try {
      await navigator.clipboard.writeText(pinIds.join('\n'));
      window.ALERT.success(`Copied ${formatNumber(pinIds.length)} ${pinIds.length === 1 ? 'pin ID' : 'pin IDs'}.`);
    } catch {
      window.ALERT.error('Could not copy the pin IDs.');
    }
  };

  return (
    <div className='creation-request-park-report'>
      <ul className='crp-facts'>
        {facts.map(fact => (
          <li key={fact.key} className={fact.isTotal ? 'total' : undefined}>
            <strong>{formatNumber(report[fact.key])}</strong> {fact.label}
          </li>
        ))}
      </ul>
      {estimate && (
        <p className='crp-estimate'>
          <span>Cost: {estimate.cost}</span>
          <span>Time: {estimate.time}</span>
        </p>
      )}
      {skippedReasons.length > 0 && (
        <div className='crp-skipped'>
          <h3>{isCheck ? 'Pins that will not be parked' : 'Pins not parked'}</h3>
          <ul>
            {skippedReasons.map(([reason, pinIds]) => (
              <li key={reason}>
                <span>
                  <strong>{formatNumber(pinIds.length)}</strong> {getCreationReasonCopy(reason)}
                </span>
                <button type='button' className='se-btn' onClick={() => copyPinIds(pinIds)}>
                  Copy pin IDs
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
      {chunkCount > 1 && <p className='crp-note'>Counts are approximate where pins in different chunks of 1,000 share a link.</p>}
    </div>
  );
};

CreationRequestParkReport.propTypes = {
  report: PropTypes.object.isRequired,
  isCheck: PropTypes.bool,
  lane: PropTypes.object,
  chunkCount: PropTypes.number.isRequired
};

export default CreationRequestParkReport;
